export interface Widget {
	id: number;
	type: WidgetType;
	priority: number;
	name: string;
	content: unknown;
	personId: number;
}

export enum WidgetType {
	INDICATOR = 'Indicator',
	INFORMATION = 'Information'
}

export interface CustomWidget {
	widget: Widget;
}
